/**
 * Buffer binding flag.
 */
export enum BufferBindFlag {
  /** Vertex buffer binding flag */
  VertexBuffer,
  /** Index buffer binding flag */
  IndexBuffer
}
